// Angular
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

// RxJS
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Services
import * as auth from 'app/auth/service/index';
import * as HttpService from 'app/http/service/index';
import { CoreConfigService } from '@core/services/config.service';

// External Modules
import ObjectID from 'bson-objectid';

@Component({
  selector: 'app-auth-login',
  templateUrl: './auth-login.component.html',
  styleUrls: ['./auth-login.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AuthLoginComponent implements OnInit, OnDestroy {
  //  Public
  public coreConfig: any;
  public loading = false;
  public returnUrl = '/pages/app/centers';
  public error = '';

  // Private
  private _unsubscribeAll: Subject<any>;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _coreConfigService: CoreConfigService,
    private _httpResponseService: HttpService.ResponseService,
    private _authenticationService: auth.AuthenticationService,
  ) {
    // redirect to home if already logged in
    if (this._authenticationService.isOnline) {
      this._router.navigate([this.returnUrl]);
    }

    this._unsubscribeAll = new Subject();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  getFile(event: Event) {
    const target = event.target as HTMLInputElement;

    // Loading
    this.loading = true;

    // Parse file
    const file = target.files[0];
    const fileReader = new FileReader();
    fileReader.onload = (): void => {
      this.verifyFile(JSON.parse(fileReader.result as string));
    };
    fileReader.readAsText(file);
  }

  verifyFile(file: any): void {
    if (!file.hasOwnProperty('_id') || !file.hasOwnProperty('key')) {
      this.error = 'El archivo no tiene el formato válido.';
    }

    if (typeof file._id !== 'string' || typeof file.key !== 'string') {
      this.error = 'El archivo no tiene el formato válido.';
    }

    if (!ObjectID.isValid(file._id) || new Blob([file.key]).size !== 350) {
      this.error = 'El archivo no tiene el formato válido.';
    }

    this.login(file._id, file.key);
  }


  login(idUser: string, key: string): Subscription {
    return this._authenticationService.login(idUser, key).subscribe({
      next: () => {
        this._router.navigate([this.returnUrl]);
      },
      error: (err) => {
        this._httpResponseService.manageErrors(err);
        // Loading
        this.loading = false;
      },
    });
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    // get return url from route parameters or default to '/dashboard'
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/pages/app/centers';

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config: any) => {
      this.coreConfig = config;
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
